import React from 'react';

const CalendlyWidget = ({ url }) => {
  return (
    <div 
      className="calendly-inline-widget"
      data-url={url}
      style={{ minWidth: "320px", height: "630px" }}
    />
  );
};

export default CalendlyWidget;